import React from 'react';

import domainNameIMG from './img/Video-02.jpg';
import transferIMG from './img/Video-01.jpg';
import {__t} from '../common/lang/text-resource';

const initialState = {
	data: {

		// ------------- Category -> Selected  ----------------
		selected: [
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Специални (premium) домейни'),
				category_id: 'selected',
				url: 'https://help.superhosting.bg/special-premium-domains.html',
				videoThumb: '',
				description: __t('специалните-premium-домейни-се-различават-от-стан1d770e')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('цени-за-възстановяване-на-изтекъл-домейн-Redempti4b6088'),
				category_id: 'selected',
				url: 'https://help.superhosting.bg/domain-restore-prices-redemption.html',
				videoThumb: '',
				description: __t('вижте-всички-цени-за-възстановяване-на-изтекъл-до9fe1ef')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Как да насоча домейна към хостинг акаунта ми?'),
				category_id: 'selected',
				url: 'https://help.superhosting.bg/how-to-point-domain-to-hosting-account.html',
				videoThumb: '',
				description: __t('насочването-на-домейн-към-определен-хостинг-акаун2192f4')
			},
			{
				hasVideo: true,
				videoId: 'p15ptq01cn',
				heading: __t('5 + 1 съвета при избор на домейн (видео)'),
				category_id: 'selected',
				url: 'https://help.superhosting.bg/tips-choosing-domain.html',
				videoThumb: domainNameIMG,
				description: __t('намирането-на-подходящото-домейн-име-първоначалноa4e040')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Какви думи да използвам в домейн името?'),
				category_id: 'selected',
				url: 'https://help.superhosting.bg/what-words-to-use-in-my-domain-name.html',
				videoThumb: '',
				description: __t('правилният-подбор-на-ключовите-думи-в-домейна-в-з315084')
			}
		],
		'reg-dom': [
			// ------------- Category -> reg-dom  ----------------
			{
				hasVideo: true,
				videoId: 'p15ptq01cn',
				heading: __t('5 + 1 съвета при избор на домейн (видео)'),
				category_id: 'reg-dom',
				url: 'https://help.superhosting.bg/tips-choosing-domain.html',
				videoThumb: domainNameIMG,
				description: __t('намирането-на-подходящото-домейн-име-първоначалноa4e040')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Какви думи да използвам в домейн името?'),
				category_id: 'reg-dom',
				url: 'https://help.superhosting.bg/what-words-to-use-in-my-domain-name.html',
				videoThumb: '',
				description: __t('правилният-подбор-на-ключовите-думи-в-домейна-в-з315084')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('По-къс или по-дълъг домейн?'),
				category_id: 'reg-dom',
				url: 'https://help.superhosting.bg/long-or-short-domain-name.html',
				videoThumb: '',
				description: __t('на-въпроса-по-къс-или-по-дълъг-трябва-да-бъде-еди0e9f07')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Името на фирмата ли е най-подходящо за домейн?'),
				category_id: 'reg-dom',
				url: 'https://help.superhosting.bg/business-name-for-domain-name.html',
				videoThumb: '',
				description: __t('при-избора-на-домейн-име-когато-го-избирате-за-фи7b985d')
			},
		],
		'man-dom': [
			// ------------- Category -> man-dom  ----------------
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Как да насоча домейна към хостинг акаунта ми?'),
				category_id: 'man-dom',
				url: 'https://help.superhosting.bg/how-to-point-domain-to-hosting-account.html',
				videoThumb: '',
				description: __t('насочването-на-домейн-към-определен-хостинг-акаун2192f4')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Домейни .BG'),
				category_id: 'man-dom',
				url: 'https://help.superhosting.bg/category/domains/bgdomain',
				videoThumb: '',
				description: __t('вижте-отговорите-на-всички-често-задавани-въпросиf1b105')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Верификация на контактните данни (Whois) за домейн'),
				category_id: 'man-dom',
				url: 'https://help.superhosting.bg/whois-data-validation.html',
				videoThumb: '',
				description: __t('според-изискванията-на-ICANN-за-валидиране-на-Who1dbf8a')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('какви-са-вашите-DNS-настройки-DNS-сървъри-на-супеabab9a'),
				category_id: 'man-dom',
				url: 'https://help.superhosting.bg/superhosting-dns.html',
				videoThumb: '',
				description: __t('за-предоставянето-на-хостинг-услуги-суперхостинг-507766')
			},
		],
		'transfer-dom': [
			// ------------- Category -> transfer-dom  ----------------
			{
				hasVideo: true,
				videoId: 'pu4b2o8mb3',
				heading: __t('Трансфер на домейн (com, net, org, biz, info) (видео)'),
				category_id: 'transfer-dom',
				url: 'https://help.superhosting.bg/domain-transfer.html',
				videoThumb: transferIMG,
				description: __t('какво-означава-трансфер-на-домейн-как-да-стартираc89f49')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Как да стартирам трансфер на домейн?'),
				category_id: 'transfer-dom',
				url: 'https://help.superhosting.bg/how-to-transfer-domain.html',
				videoThumb: '',
				description: __t('преди-да-стартирате-трансфер-на-домейн-е-нужно-да54eedb')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Статуси при трансфер на домейн'),
				category_id: 'transfer-dom',
				url: 'https://help.superhosting.bg/domain-transfer-statuses.html',
				videoThumb: '',
				description: __t('след-като-сте-стартирали-трансфер-на-домейн-в-кли83dd3b')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('какво-е-EPP-ключ-Auth-код-за-трансфер-и-как-да-гоcb9761'),
				category_id: 'transfer-dom',
				url: 'https://help.superhosting.bg/epp-key.html',
				videoThumb: '',
				description: __t('еPP-ключ-или-Auth-код-представлява-допълнителен-к2df8a6')
			},
		]
	},
	data_en: {

		// ------------- Category -> Selected  ----------------
		selected: [
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Специални (premium) домейни'),
				category_id: 'selected',
				url: 'https://help.superhosting.bg/en/special-premium-domains.html',
				videoThumb: '',
				description: __t('специалните-premium-домейни-се-различават-от-стан1d770e')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('цени-за-възстановяване-на-изтекъл-домейн-Redempti4b6088'),
				category_id: 'selected',
				url: 'https://help.superhosting.bg/en/domain-restore-prices-redemption.html',
				videoThumb: '',
				description: __t('вижте-всички-цени-за-възстановяване-на-изтекъл-до9fe1ef')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Verify contact data (Whois) for your domains'),
				category_id: 'selected',
				url: 'https://help.superhosting.bg/en/whois-data-validation.html',
				videoThumb: '',
				description: __t('As of January 1st, 2014 ICANN requires that-49kfwjj2')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('How to Change My DNS Servers?'),
				category_id: 'selected',
				url: 'https://help.superhosting.bg/en/how-to-change-dns.html',
				videoThumb: '',
				description: __t('how-to-change-my-dns-servers?-з315084')
			}
		],
		'man-dom': [
			// ------------- Category -> man-dom  ----------------
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Verify contact data (Whois) for your domains'),
				category_id: 'man-dom',
				url: 'https://help.superhosting.bg/en/whois-data-validation.html',
				videoThumb: '',
				description: __t('As of January 1st, 2014 ICANN requires that-49kfwjj2')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Changing Your Domain DNS Settings'),
				category_id: 'man-dom',
				url: 'https://help.superhosting.bg/en/dns-hosting.html',
				videoThumb: '',
				description: __t('if-you-are-unable-to-associate-а-domain-wit-93lks92')
			},
		],
		'transfer-dom': [
			// ------------- Category -> transfer-dom  ----------------
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Трансфер на домейн (com, net, org, biz, info) (видео)'),
				category_id: 'transfer-dom',
				url: 'https://help.superhosting.bg/en/domain-transfer.html',
				videoThumb: transferIMG,
				description: __t('какво-означава-трансфер-на-домейн-как-да-стартираc89f49')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Как да стартирам трансфер на домейн?'),
				category_id: 'transfer-dom',
				url: 'https://help.superhosting.bg/en/how-to-transfer-domain.html',
				videoThumb: '',
				description: __t('преди-да-стартирате-трансфер-на-домейн-е-нужно-да54eedb')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Ive-Initiated-a-Domain-Transfer-through-My-Custom707e26'),
				category_id: 'transfer-dom',
				url: 'https://help.superhosting.bg/en/next-step-transfer-domain.html',
				videoThumb: '',
				description: __t('once-the-domain-transfer-is-started-in-92ja1i1')
			},
			{
				hasVideo: false,
				videoId: '',
				heading: __t('Статуси при трансфер на домейн'),
				category_id: 'transfer-dom',
				url: 'https://help.superhosting.bg/en/domain-transfer-statuses.html',
				videoThumb: '',
				description: __t('след-като-сте-стартирали-трансфер-на-домейн-в-кли83dd3b')
			},
		]
	},
	categories: [
		{label: __t('Избрано'), value: 'selected'},
		{label: __t('Регистрация на домейн'), value: 'reg-dom'},
		{label: __t('Управление на домейн'), value: 'man-dom'},
		{label: __t('Прехвърляне на домейн'), value: 'transfer-dom'},
	],
	categories_en: [
		{label: __t('Избрано'), value: 'selected'},
		{label: __t('Управление на домейн'), value: 'man-dom'},
		{label: __t('Прехвърляне на домейн'), value: 'transfer-dom'},
	],
};


const ContextDomainAdditionalInfo = React.createContext(initialState);

export default ContextDomainAdditionalInfo;